import DataSourceAnalysisResult from './Types/DataSourceAnalysisResult';
import dataSourceKind from '../../../infrastructure/constants/dataSourceKind';
import ReportConfigBundle from '../../../types/report/import/ReportConfigBundle';
import ReportFieldDefinition from '../../../types/report/ReportFieldDefinition';
import typeHelper from '../../../infrastructure/helpers/common/typeHelper';
import IngestionConfig from '../../../types/ingestion/IngestionConfig';
import IdMaps from '../../../types/report/import/IdMaps';

const handleDataSource = (current: IngestionConfig, dataSources: IngestionConfig[], result: DataSourceAnalysisResult): void => {

    let currentName = current.name.toLowerCase()

    let clientDataSourcesNames = result.missingClientDataSources.map(x => x.toLowerCase());

    if (current.dataSourceKind === dataSourceKind.globalRef || current.dataSourceKind === dataSourceKind.accuracy) {

        let id = dataSources.find(x => x.name.toLowerCase() === currentName)?.id as number;

        if (typeHelper.isNumber(id)) {

            result.maps.dataSource[current.id as number] = id;
        }
    }
    else {
        let dataSource = dataSources.filter(x => x.name.toLowerCase() === currentName).sort((a, b) => { return a.id as number < (b.id as number) ? 1 : (b.id as number) < (a.id as number) ? -1 : 0 })[0] as IngestionConfig;

        if (typeHelper.isObject(dataSource)) {

            result.maps.dataSource[current.id as number] = dataSource.id as number;
        }
        else {
            if (!clientDataSourcesNames.includes(currentName)) {

                result.missingClientDataSources.push(currentName);
            }
        }
    }
}

const handleReportField = (name: string, bundle: ReportConfigBundle, reportFields: ReportFieldDefinition[], result: DataSourceAnalysisResult): void => {

    let definition = reportFields.find(x => x.name === name) as ReportFieldDefinition;

    if (typeHelper.isObject(definition)) {

        let id = bundle.reportFields.find(x => x.name === name)?.id as number;

        result.maps.reportField[id] = definition.id;
    }
    else {
        result.missingReportFields.push(name);
    }
};

const analyse = (bundle: ReportConfigBundle, reportFields: ReportFieldDefinition[], dataSources: IngestionConfig[], maps?: IdMaps): DataSourceAnalysisResult => {

    let result: DataSourceAnalysisResult = {
        missingClientDataSources: [],
        missingDataSourcesFields: [],
        disabledClientDataSources: [],
        missingReportFields: [],
        maps: maps || {
            dataSource: {},
            dataSourceField: {},
            reportField: {}
        },
        proceed: false
    };

    addDatasourcesToResult(bundle.dataSources, dataSources, result);

    if (!maps) {
        bundle.reportFields.forEach(field => handleReportField(field.name, bundle, reportFields, result));
    }

    return result;
};

const addDatasourcesToResult = (dataSources: IngestionConfig[], dataSourcesInDb: IngestionConfig[], result: DataSourceAnalysisResult) => {
    dataSources.forEach(x => handleDataSource(x, dataSourcesInDb, result));
}

export { analyse, addDatasourcesToResult };